import React from 'react';
import { Grid } from '@mui/material';
import { SelectForm } from 'features/common';
import T from 'i18n';

const ClassifyContent = (props) => {
  const { 
    classifyFolderToOptions, 
    classifyFolderType, 
    setClassifyFolderType, 
    control, 
    errors 
  } = props;

  return (
    <>
      <Grid container direction="column" spacing={1} padding={1}>
        <Grid container style={{ paddingTop: 5 }}>
          <Grid item xs={6}>
            <SelectForm
              name="classifyType"
              onChange={(val) => setClassifyFolderType(val)}
              label={T.translate(`case.ClassifyInto`)}
              options={[
                {
                  label: T.translate(`case.cloneIntoOptions.teamBundles`),
                  value: 'team-bundle',
                },
                {
                  label: T.translate(`case.cloneIntoOptions.privateBundles`),
                  value: 'private-bundle',
                },
              ]}
              control={control}
              errors={errors}
              rules={{ required: true }}
              menuPosition="fixed"
            />
          </Grid>
        </Grid>
        <Grid container style={{ paddingTop: 5, marginTop: 5 }}>
          <Grid item xs={6}>
            <SelectForm
              name="classifyParentFolderId"
              label={T.translate(`case.classifyToFolder`)}
              valueKey="id"
              labelKey="name"
              options={classifyFolderToOptions}
              control={control}
              errors={errors}
              menuPosition="fixed"
              readOnly={!classifyFolderType}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ClassifyContent;
